import React, { useState } from 'react'
import { Button, Modal } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import '../login/login.scss'
import logo from 'src/assets/images/1journey.png'
import art from 'src/assets/images/readingbook.png'

const ArrowIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
)

const EmailConfirmation = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const location = useLocation()
  let responseData = location.state || {}

  if (!Object.keys(responseData).length) {
    try {
      responseData = JSON.parse(sessionStorage.getItem('studentRegistrationConfirmation') || '{}')
    } catch {
      responseData = {}
    }
  }

  const showModal = () => setIsModalVisible(true)
  const handleCancel = () => setIsModalVisible(false)
  const openGmail = () => window.open('https://mail.google.com', '_blank')
  const openOutlook = () => window.open('https://outlook.live.com', '_blank')
  const openHotmail = () => window.open('https://outlook.live.com/owa/', '_blank')
  if (!responseData.studentName || !responseData.studentEmail || !responseData.platformEmail) {
    return (
      <div className="jl">
        <div className="jl__shell">
          <main className="jl__panel">
            <div className="jl__card">
              <span className="jl__spinner" aria-hidden="true" />
              <p className="jl__sub" style={{ marginTop: '1rem' }}>
                Loading&hellip;
              </p>
            </div>
          </main>
        </div>
      </div>
    )
  }

  return (
    <div className="jl">
      <div className="jl__shell">
        {/* ---------- Brand / hero ---------- */}
        <aside className="jl__hero jl__hero--art">
          <div className="jl__aurora" aria-hidden="true">
            <span className="jl__orb jl__orb--a" />
            <span className="jl__orb jl__orb--b" />
            <span className="jl__orb jl__orb--c" />
            <span className="jl__beam" />
            <span className="jl__grid" />
          </div>

          <div className="jl__art">
            <span className="jl__art-glow" aria-hidden="true" />
            <img src={art} alt="A student reading" className="jl__art-img" />
            <div className="jl__art-tag">
              <span>1Journey</span>
              <strong>One step away</strong>
            </div>
          </div>
        </aside>

        {/* ---------- Confirmation content ---------- */}
        <main className="jl__panel">
          <div className="jl__card">
            <img src={logo} alt="1Journey" className="jl__card-logo" />
            <span className="jl__eyebrow">Set your password</span>
            <h2 className="jl__title">Almost there</h2>
            <p className="jl__sub">Dear {responseData.studentName}, thanks for joining us.</p>
            {responseData.isRetry ? (
              <p className="jl__sub">
                We&apos;ve re-sent your set-password link to finish an earlier sign-up.
              </p>
            ) : null}

            <p className="jl__sub">
              Thank you for signing up for{' '}
              <Link to="https://1journey.ai/" target="_blank" className="jl__link">
                1journey.ai
              </Link>
              . We&apos;re excited to have you on board.
            </p>

            <p className="jl__sub">
              Please check your inbox or spam folder at{' '}
              <a href={`mailto:${responseData.studentEmail}`} className="jl__link">
                {responseData.studentEmail}
              </a>{' '}
              for an email from{' '}
              <a href={`mailto:${responseData.platformEmail}`} className="jl__link">
                {responseData.platformEmail}
              </a>{' '}
              with a link to set your password. Once you set it, you can sign in and access your
              account. The link expires after 7 days.
            </p>

            {responseData.isParentAdded ? (
              <p className="jl__sub">
                Your parent with email{' '}
                <a href={`mailto:${responseData.parentEmail}`} className="jl__link">
                  {responseData.parentEmail}
                </a>{' '}
                has been connected with you. Please inform them to check their email for a link to
                set their password and finish setting up their account.
              </p>
            ) : (
              <p className="jl__sub">
                The parent with email{' '}
                <a href={`mailto:${responseData.parentEmail}`} className="jl__link">
                  {responseData.parentEmail}
                </a>{' '}
                already has an account with us and is now connected with you.
              </p>
            )}

            <p className="jl__sub">
              Thank you once again for registering for our{' '}
              <Link to="https://1journey.ai/" target="_blank" className="jl__link">
                1journey.ai
              </Link>
              . In case of any questions, contact the support team at{' '}
              <a href={`mailto:${responseData.platformEmail}`} className="jl__link">
                {responseData.platformEmail}
              </a>
              .
            </p>

            <p className="jl__sub">
              Best regards,
              <br />
              <Link to="https://1journey.ai/" target="_blank" className="jl__link">
                1journey.ai
              </Link>
            </p>

            <button type="button" className="jl__btn" onClick={showModal}>
              Go to Mail <ArrowIcon />
            </button>
          </div>

          <p className="jl__copy">© {new Date().getFullYear()} 1Journey · Learn, Grow, Achieve.</p>
        </main>
      </div>

      <Modal
        title="Select Email Provider"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={420}
      >
        <Button type="primary" style={{ marginRight: '10px' }} onClick={openGmail}>
          Open Gmail
        </Button>
        <Button type="primary" style={{ marginRight: '10px' }} onClick={openOutlook}>
          Open Outlook
        </Button>
        <Button type="primary" onClick={openHotmail}>
          Open hot mail
        </Button>
      </Modal>
    </div>
  )
}

export default EmailConfirmation
